/**
 * Compile-time exhaustiveness guard for discriminated unions.
 * Every switch on a union type should end with `default: assertNever(action)`.
 * If a new variant is added later, the compiler refuses this call.
 */
export function assertNever(value: never): never {
  throw new Error(`Unhandled case: ${JSON.stringify(value)}`);
}
